<template>
  <div class="payments">
    <div class="payments__tabs">
      <router-link to="/" exact class="payments__tab">{{
        $t("payments.tab.create_payment")
      }}</router-link>
      <router-link to="/archive" exact class="payments__tab">{{
        $t("payments.tab.archive_payments")
      }}</router-link>
      <!--      <router-link to="/compare-pos" exact class="payments__tab">{{-->
      <!--        $t("payments.tab.compare-pos")-->
      <!--      }}</router-link>-->
    </div>
    <div class="payments__tab-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Payments",
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.payments {
  width: 100%;
  margin-top: -50px;

  &__tabs {
    display: flex;
    align-items: center;
  }

  &__tab {
    height: 50px;
    font-size: pxToRem(14);
    line-height: pxToRem(15);
    padding-left: 34px;
    padding-right: 51px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-bottom: unset;
    color: $textDark;
    border-radius: 16px 90px 0 0;
    text-decoration: none;

    &-content {
      padding-bottom: 30px;
    }

    &.router-link-exact-active {
      border-color: #f0f3fa;
      color: $action;
    }
  }
}
</style>
